import { on, reducer } from "ts-action";

import { loadSitzungenListe } from "./sitzungen-actions.js";
import type { SitzungenListe } from "../service/sitzungen-service.js";

export interface SitzungenState {
  liste?: SitzungenListe;
  /** Meldung, wenn das Artefakt nicht erreichbar war — die Seite sagt es. */
  listeFehler?: string;
}

const initialState: SitzungenState = {};

export const sitzungenReducer = reducer<SitzungenState>(
  initialState,
  on(loadSitzungenListe.success, (state, { payload }) => ({
    ...state,
    liste: payload,
    listeFehler: undefined,
  })),
  on(loadSitzungenListe.fail, (state, { payload }) => ({
    ...state,
    listeFehler: payload instanceof Error ? payload.message : String(payload),
  })),
);
